import { render, staticRenderFns } from "./IngredientData.vue?vue&type=template&id=49204f56&scoped=true&"
import script from "./IngredientData.vue?vue&type=script&lang=js&"
export * from "./IngredientData.vue?vue&type=script&lang=js&"
import style0 from "./IngredientData.vue?vue&type=style&index=0&id=49204f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49204f56",
  null
  
)

export default component.exports